// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2AEuy","imageUploader":"EGiftCard_imageUploader__1T6Ln"};